import { render, staticRenderFns } from "./skuQuery_s1.vue?vue&type=template&id=1d5cd784&scoped=true&"
import script from "./skuQuery_s1.vue?vue&type=script&lang=js&"
export * from "./skuQuery_s1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5cd784",
  null
  
)

export default component.exports